export default "__VITE_ASSET__bfff2f20__"